// Main page events
export const HIBB_USER_VIEWED_MAIN_PAGE = 'hibb_user_viewed_main_page';
export const HIBB_USER_INPUT_EMAIL = 'hibb_user_input_email';
export const HIBB_USER_INPUT_PHONE = 'hibb_user_input_phone';
export const HIBB_USER_INPUT_SUBMIT = 'hibb_user_input_submit';

// Results page events
export const HIBB_USER_VIEWED_RESULTS_PAGE = 'hibb_user_viewed_results_page';
export const HIBB_RESULTS_PAGE_PHONE_ENTERED_STEPS_CTA = 'hibb_results_page_phone_entered_steps_CTA';
export const HIBB_RESULTS_PAGE_PHONE_ENTERED_MAIN_CTA = 'hibb_results_page_phone_entered_main_CTA';